import { reactive } from 'vue'
import { speciaBehiver, specialCheck } from '@/define/limit'
import { DeviceManager } from '../device'
import { setOrRead } from './set_read'
import { SpecificItem } from '@libs/types/enum'
import { DevicePid } from '@/define/define'
import firmware from '@/upgrade/firmware'
class PowerSet {
  state = reactive({
    power: 0, // 当前电量
    isCharging: false, // 是否在充电
    amberMouseGetPowerCount: 0, // 琥珀鼠标第一次获取电量是0，提示用户正在获取电量中
  })

  private batteryStatusInterval: NodeJS.Timeout | null = null

  getPowerData = async () => {
    if (!specialCheck(speciaBehiver.ShowBattery, DeviceManager.instance.state.currentPid)) return

    if (specialCheck(speciaBehiver.SpecialEquipment_WiredCharging, DeviceManager.instance.state.currentPid)) {
      this.state.isCharging = true
      this.state.power = 100
      return
    }
    const results = await Promise.allSettled([setOrRead.read<number>(SpecificItem.PowerLevel), setOrRead.read<number>(SpecificItem.PowerIsCharging)])
    if (results[0].status === 'fulfilled') {
      this.state.power = results[0].value
      if (DeviceManager.instance.state.currentPid == DevicePid.IYXAmber358_24g8k) {
        this.state.amberMouseGetPowerCount += 1
      }
    } else {
      console.error('Failed to fetch PowerLevel:', results[0].reason)
    }
    if (results[1].status === 'fulfilled') {
      this.state.isCharging = results[1].value === 1 // 获取成功的值
      this.handleBatteryStatusPolling()
    } else {
      console.error('Failed to fetch PowerIsCharging:', results[1].reason)
    }
    // return this.power.value;
  }

  clear() {
    this.state.amberMouseGetPowerCount = 0
    this.clearBatteryStatusInterval()
  }

  //处理设备轮询电量
  private async handleBatteryStatusPolling() {
    const version = await firmware.versionRoYuanV304()
    if (!version) {
      return
    }
    this.startBatteryStatusPolling()
  }

  // 第一次请求成功后，30秒轮询一次 获取电量状态
  private startBatteryStatusPolling() {
    this.clearBatteryStatusInterval()
    this.batteryStatusInterval = setInterval(async () => {
      const status = await setOrRead.read<number>(SpecificItem.PowerIsCharging)
      this.state.isCharging = status == 1 ? true : false
    }, 1000 * 30)
  }
  private clearBatteryStatusInterval() {
    if (this.batteryStatusInterval) {
      clearInterval(this.batteryStatusInterval)
      this.batteryStatusInterval = null
    }
  }
}
let powerSet = new PowerSet()
export { powerSet }
